import React, { useEffect, useState } from "react";
import { ReactComponent as Logo } from "../../../assets/logo_horizontal_color.svg";
import duneLogo from "../../../assets/dune-logo.png";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { isShared } from "../../../utils";
import { UserBar } from "./components/UserBar";
import { APP_MODES, isDune, isLanding } from "../../../constants/common";
import { normalizeAlias } from "./utils";
import SnowEffect from "../SnowEffect";

export const Header = ({ setSideMenuIsOpen }) => {
  const location = useLocation();
  const alias = normalizeAlias(location.pathname);
  const currentModeKey = Object.keys(APP_MODES).find(
    (key) => APP_MODES[key].alias === alias,
  );
  const navigate = useNavigate();

  const [mode, setMode] = useState(APP_MODES[currentModeKey]?.id);

  const handleChooseMode = (mode: number) => {
    const targetMode = Object.values(APP_MODES).find(
      (item) => item.id === mode,
    );

    if (targetMode) {
      setMode(targetMode.id);
      navigate(targetMode.alias);
    }
  };

  useEffect(() => {
    setMode(APP_MODES[currentModeKey]?.id);
  }, [alias]);

  const headerClass =
    "flex justify-between items-center text-[32px] h-[80px] px-5 box-border" +
    (isLanding
      ? " bg-transparent"
      : " bg-white shadow-[0_2px_24px_0_#00000020]");

  return (
    <div className={headerClass}>
      {!isShared && !isLanding && (
        <>
          <Link to="/">
            <div className="h-[30px] w-[150px]">
              {isDune ? (
                <img src={duneLogo} alt="logo" style={{ height: "100%" }} />
              ) : (
                <Logo width="100%" height="100%" />
              )}
            </div>
          </Link>

          <div className="flex items-center">
            <SnowEffect />
            <UserBar setSideMenuIsOpen={setSideMenuIsOpen} />
          </div>
        </>
      )}

      {isShared && !isLanding && (
        <div className="h-[30px] w-[150px]">
          {isDune ? (
            <img src={duneLogo} alt="logo" style={{ height: "100%" }} />
          ) : (
            <Logo width="100%" height="100%" />
          )}
        </div>
      )}
    </div>
  );
};
